<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <input id="fileInput" type="file" class="hidden" (input)="onSelectFile($event)" />
    <button
        (click)="onUpload('fileInput')"
        class="pr-24 mr-24 mb-24 choose-button"
        aria-label="attach_file"
        mat-raised-button
        color="accent">
        <mat-icon class="icon-action">add_a_photo</mat-icon>
        <span class="display-text">Choose file</span>
    </button>
    <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Upload document</mat-label>
        <input matInput type="text" placeholder="No file chosen" value="{{ fileName }}" />
        <mat-progress-bar color="primary" [bufferValue]="bufferValue" [mode]="mode" [value]="processPercent"></mat-progress-bar>
    </mat-form-field>
</div>
